import { errorToast, successToast } from "../../toast";
import DialogBox from "../DialogBox";
import { Alert } from "@mui/material";
import Button from "../Button";
import { ApiFetcherResponse } from "../../api/common/useAuthenticatedFetcher";

type RemoveRequiredEvidenceDialogProps = {
    isOpen: boolean;
    onClose: (evidenceTypeRemoved: boolean) => void;
    request: () => Promise<ApiFetcherResponse<unknown>>;
    isSubmitting: boolean;
};

const RemoveRequiredEvidenceDialog = ({
    isOpen,
    onClose,
    request,
    isSubmitting,
}: RemoveRequiredEvidenceDialogProps) => {
    const handleRemoveRequiredEvidenceFormSubmission = async () => {
        const response = await request();

        if (!response.success) {
            errorToast(
                "There was a problem removing the required evidence type - please try again"
            );
            return;
        }

        successToast("Required evidence type removed");
        onClose(true);
    };

    return (
        <>
            <DialogBox
                title="Remove required evidence type"
                isOpen={isOpen}
                onClose={() => onClose(false)}
                className="max-w-lg"
            >
                <Alert severity="info" className="items-center">
                    This evidence type will no longer be required. Evidence that
                    has already been added will persist but will no longer be
                    visible in this table. If you re-add a removed evidence type
                    again then you will be able to see any existing evidence.
                </Alert>
                <div className="flex justify-end gap-4 mt-10">
                    <Button
                        variant="transparent"
                        type="button"
                        onClick={() => onClose(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={isSubmitting}
                        onClick={handleRemoveRequiredEvidenceFormSubmission}
                    >
                        Remove
                    </Button>
                </div>
            </DialogBox>
        </>
    );
};

export default RemoveRequiredEvidenceDialog;
